import { z } from 'zod';

export const loginFormSchema = z.object({
  username: z.string().min(1, 'auth.errors.usernameRequired'),
  password: z.string().min(1, 'auth.errors.passwordRequired'),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
